import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast';
import { editWallet } from 'services/apiUserCreditManagement';

const useEditUserWallet = () => {
  const queryClient = useQueryClient();
  const{isPending:isEditing,isSuccess:isEdited,mutate: editUserWallet}=useMutation({
    mutationFn: editWallet,
    onSuccess:(data)=>{
        queryClient.setQueryData(['updatedUserWallet'],data)
        queryClient.invalidateQueries({queryKey:['usersCredits']})
        toast.success("Wallet Updated Successfully",{id:"wallet-update"})
    },
    onError:(error)=>{
        console.log("Error occurred while updating wallet",error)
        if(error?.data && typeof error.data === 'object'){
            for (const key in error.data){
                const msg = error.data[key];
                toast.error(Array.isArray(msg) ? msg[0] : msg)
            }
        }else{
            toast.error(error.message || "Something went wrong")
        }
    }
  })

  return{isEditing,isEdited,editUserWallet}
}

export default useEditUserWallet

